<p-panel [toggleable]="true" [collapsed]="false">
  <p-header><h3>Overview</h3></p-header>
  <div class="p-grid">
    @for (budget of budgetOverview; track budget) {
      <div class="overview-card">
        <p-card class="p-card">
          <div class="budget-field-label budget-name-label">
            <label><b>{{budget.budgetName}}</b></label>
          </div>
          <div class="p-grid">
            <div class="p-col-10" style="align-items: center; margin-right: -8.5rem;">
              <div class="p-field month-budget-field">
                <label>Month Budget</label>
                <label><b>${{stringFormatterService.formatNumberToString(budget.monthBudget)}} (${{stringFormatterService.formatNumberToString(budget.dailyBudget)}}/day)</b></label>
              </div>
              <p-progressBar class="p-progressbar" [style]="{'border-radius': '50px'}" [value]=budget.progressPercent></p-progressBar>
            </div>
          </div>
          <div class="card-footer">
            <div class="p-field">
              <label class="overview-label">Spend to Date</label>
              <label class="overview-label"><b>${{stringFormatterService.formatNumberToString(budget.spendToDate)}}</b></label>
            </div>
            <div class="p-field">
              <label class="overview-label">Target Spend</label>
              <label class="overview-label"><b>${{stringFormatterService.formatNumberToString(budget.targetSpend)}}</b></label>
            </div>
            <div class="p-field">
              <label class="overview-label">Pacing</label>
              <label class="overview-label" [ngClass]="{'ten-off-pace': budget.pacing < 90 || budget.pacing > 110, 'twenty-off-pace': budget.pacing < 80 || budget.pacing > 120}"><b>{{budget.pacing}}%</b></label>
            </div>
            <div class="p-field">
              <label class="overview-label">Left to Spend</label>
              <label class="overview-label"><b>${{stringFormatterService.formatNumberToString(budget.leftToSpend)}}</b></label>
            </div>
            <div class="p-field">
              <label class="overview-label">New Daily Budget</label>
              <label class="next-day-budget-label"><b>${{stringFormatterService.formatNumberToString(budget.newDailyBudget)}}</b></label>
            </div>
          </div>
        </p-card>
      </div>
    }
  </div>
</p-panel>
<p-panel [toggleable]="true" [collapsed]="true">
  <p-header><h3>Active Budgets</h3></p-header>
  @for (budget of activeBudgetManagements; track budget; let i = $index) {
    <div>
      <label class="budget-field-label"><b>{{budget.salesforceBudgetName}}</b></label>
      <label class="budget-field-label">Budget: ${{stringFormatterService.formatNumberToString(budget.totalBudget)}}</label>
      @if (budgetType === 'Heavy-Up') {
        <label class="budget-field-label">Adjusted Salesforce Budget: ${{stringFormatterService.formatNumberToString(budget.adjustedTotalBudget)}}</label>
      }
      <label class="budget-field-label">Start Date: {{budget.startDate.date | date:'shortDate'}}</label>
      <label class="budget-field-label">End Date: {{budget.endDate.date | date:'shortDate'}}</label>
      @if (budget.lastUpdatedDate) {
        <label class="budget-field-label">Last Updated: {{budget.lastUpdatedDate | date:'shortDate'}}</label>
      }
      @if (budget.lastUpdatedUser) {
        <label class="budget-field-label">Updated By: {{budget.lastUpdatedUser}}</label>
      }
      <div class="p-grid field-form-wrapper">
        @if (budget.campaignBudgets) {
          <form [formGroup]="activeBudgetConfigurationFormGroups[i]"
            autoTrackUnsavedChanges class="p-col">
            <table class="p-datatable full-table">
              <thead class="p-datatable-thead">
                <tr class="p-datatable-header">
                  <th style="text-align:center">
                    Google Budget
                  </th>
                  <th style="text-align:center">
                    Percentage
                    @if (budgetType === 'Standard') {
                      <span
                        class="pi pi-info-circle"
                        pTooltip="Percentage of remaining Salesforce budget allocated. Remaining salesforce budget (total Salesforce budget less fixed monthly budget amounts): ${{stringFormatterService.formatNumberToString(budget.totalBudget - activeBudgetConfigurationTotalsFormGroups[i].controls.fixedAmountTotal.value)}}"
                      tooltipPosition="right"></span>
                    }
                    @if (budgetType === 'Heavy-Up') {
                      <span
                        class="pi pi-info-circle"
                        pTooltip="Percentage of remaining Salesforce budget allocated. Remaining salesforce budget (total Salesforce budget less fixed monthly budget amounts): ${{stringFormatterService.formatNumberToString(budget.adjustedTotalBudget - activeBudgetConfigurationTotalsFormGroups[i].controls.fixedAmountTotal.value)}}"
                      tooltipPosition="right"></span>
                    }
                  </th>
                  <th style="text-align:center">
                    Month Budget
                  </th>
                  <th style="text-align:center">
                    Fixed Amount
                  </th>
                  <th style="text-align:center">
                    Daily Budget
                  </th>
                </tr>
              </thead>
              <tbody class="p-datatable-tbody">
                <ng-container formArrayName="activeBudgetConfigurationFormArray">
                  @for (activeBudgetConfiguration of this.activeBudgetConfigurationFormArrays[i].controls; track activeBudgetConfiguration; let j = $index) {
                    <tr [formGroupName]="j">
                      <td style="text-align:center">{{activeBudgetConfiguration.value.budgetName}}</td>
                      <td style="text-align:center">
                        @if (activeBudgetConfiguration.value.fixedAmount) {
                          <span style="font-size: 20px; color: #212121" > -- </span>
                        }
                        @if (!activeBudgetConfiguration.value.fixedAmount) {
                          <input
                            type="number"
                            min="0"
                            max="100"
                            pInputText
                            class="text-input"
                            style="font-size: 20px; color: #212121"
                            formControlName="percentage"
                            (change)="calculateValues(i, 'active')" />
                        }
                        @if (!activeBudgetConfiguration.value.fixedAmount) {
                          <span> %</span>
                        }
                        @if (activeBudgetConfiguration.invalid) {
                          <span class="p-invalid">
                            Must be between 0 and 100
                          </span>
                        }
                      </td>
                      <td style="text-align:center">
                        $ @if (activeBudgetConfiguration.value.fixedAmount) {
                        <input
                          type="number"
                          step="0.01"
                          min="0.00"
                          class="text-input"
                           style="text-align:center;
                                 font-size: 20px;
                                 color: #212121;"
                          formControlName="totalSpend"
                          (change)="calculateValues(i, 'active')"/>
                      }
                      @if (!activeBudgetConfiguration.value.fixedAmount) {
                        <span>
                          {{stringFormatterService.formatNumberToString(activeBudgetConfiguration.value.totalSpend)}}
                        </span>
                      }
                    </td>
                    <td style="text-align:center">
                      <p-toggleswitch
                        formControlName="fixedAmount"
                        (onChange)="calculateValues(i, 'active')"
                      ></p-toggleswitch>
                    </td>
                    <td style="text-align:center">${{stringFormatterService.formatNumberToString(activeBudgetConfiguration.value.dailyBudget)}}</td>
                  </tr>
                }
              </ng-container>
              @if (!activeBudgetConfigurationTotalsFormGroups[i].invalid) {
                <tr style="background:lightgrey">
                  <td style="text-align:center"><i>Total</i></td>
                  <td
                  style="text-align:center">{{activeBudgetConfigurationTotalsFormGroups[i].controls.percentageTotal.value}} %</td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(activeBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value)}}</td>
                  <td style="text-align:center"><i> </i></td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(activeBudgetConfigurationTotalsFormGroups[i].controls.dailyBudgetTotal.value)}}</td>
                </tr>
              }
              @if (activeBudgetConfigurationTotalsFormGroups[i].invalid) {
                <tr style="background:#FF3838">
                  <td style="text-align:center"><i>Total</i></td>
                  <td
                  style="text-align:center">{{activeBudgetConfigurationTotalsFormGroups[i].controls.percentageTotal.value}} %</td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(activeBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value)}}</td>
                  <td style="text-align:center"><i> </i></td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(activeBudgetConfigurationTotalsFormGroups[i].controls.dailyBudgetTotal.value)}}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (activeBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value !== budget.totalBudget && !this.activeBudgetConfigurationFormArrays[i].dirty) {
            <div >
              The account’s Salesforce Budget was updated. Please update budget configurations.
            </div>
          }
          <div class="tab-panel-input-wrapper" style="margin-top: 12px">
            <button pButton
              class="p-button-success"
              label="Save"
              (click)="handleBudgetConfigurationSave(i,'active')"
              [disabled]="activeBudgetConfigurationTotalsFormGroups[i].invalid">
            </button>
            <button pButton
                    id="budgetUpdateNowButton"
                    [class]="(activeBudgetConfigurationTotalsFormGroups[i].invalid || activeBudgetConfigurationFormArrays[i].dirty) ? 'p-button p-button-secondary' : 'p-button p-button-info'"
                    style="margin-left: 8px"
                    [pTooltip]="(activeBudgetConfigurationTotalsFormGroups[i].invalid || activeBudgetConfigurationFormArrays[i].dirty) ?
                   (activeBudgetConfigurationTotalsFormGroups[i].invalid ? 'Budget configuration is invalid. Please fix errors before updating.' : 'Please save your changes before updating budgets.') :
                   'Immediately update Google Ads budgets based on current MPOP configuration'"
                    (click)="triggerBudgetUpdate()"
                    [disabled]="activeBudgetConfigurationTotalsFormGroups[i].invalid || activeBudgetConfigurationFormArrays[i].dirty"
                    label="Update Now">
            </button>
          </div>
        </form>
      }
    </div>
    <hr>
    </div>
  }
</p-panel>
<p-panel [toggleable]="true" [collapsed]="true">
  <p-header><h3>Future Budgets</h3></p-header>
  @for (budget of pendingBudgetManagements; track budget; let i = $index) {
    <div>
      <label class="budget-field-label"><b>{{budget.salesforceBudgetName}}</b></label>
      <label class="budget-field-label">Budget: ${{stringFormatterService.formatNumberToString(budget.totalBudget)}}</label>
      @if (budgetType === 'Heavy-Up') {
        <label class="budget-field-label">Adjusted Salesforce Budget: ${{stringFormatterService.formatNumberToString(budget.adjustedTotalBudget)}}</label>
      }
      <label class="budget-field-label">Start Date: {{budget.startDate.date | date:'shortDate'}}</label>
      <label class="budget-field-label">End Date: {{budget.endDate.date | date:'shortDate'}}</label>
      @if (budget.lastUpdatedDate) {
        <label class="budget-field-label">Last Updated: {{budget.lastUpdatedDate | date:'shortDate'}}</label>
      }
      @if (budget.lastUpdatedUser) {
        <label class="budget-field-label">Updated By: {{budget.lastUpdatedUser}}</label>
      }
      <div class="p-grid field-form-wrapper">
        @if (budget.campaignBudgets) {
          <form [formGroup]="pendingBudgetConfigurationFormGroups[i]"
            autoTrackUnsavedChanges class="p-col">
            <table class="p-datatable full-table">
              <thead class="p-datatable-thead">
                <tr class="p-datatable-header">
                  <th style="text-align:center">
                    Google Budget
                  </th>
                  <th style="text-align:center">
                    Percentage
                    @if (budgetType === 'Standard') {
                      <span
                        class="pi pi-info-circle"
                        pTooltip="Percentage of remaining Salesforce budget allocated. Remaining salesforce budget (total Salesforce budget less fixed monthly budget amounts): ${{stringFormatterService.formatNumberToString(budget.totalBudget - pendingBudgetConfigurationTotalsFormGroups[i].controls.fixedAmountTotal.value)}}"
                      tooltipPosition="right"></span>
                    }
                    @if (budgetType === 'Heavy-Up') {
                      <span
                        class="pi pi-info-circle"
                        pTooltip="Percentage of remaining Salesforce budget allocated. Remaining salesforce budget (total Salesforce budget less fixed monthly budget amounts): ${{stringFormatterService.formatNumberToString(budget.adjustedTotalBudget - pendingBudgetConfigurationTotalsFormGroups[i].controls.fixedAmountTotal.value)}}"
                      tooltipPosition="right"></span>
                    }
                  </th>
                  <th style="text-align:center">
                    Month Budget
                  </th>
                  <th style="text-align:center">
                    Fixed Amount
                  </th>
                  <th style="text-align:center">
                    Daily Budget
                  </th>
                </tr>
              </thead>
              <tbody class="p-datatable-tbody">
                <ng-container formArrayName="pendingBudgetConfigurationFormArray">
                  @for (pendingBudgetConfiguration of this.pendingBudgetConfigurationFormArrays[i].controls; track pendingBudgetConfiguration; let j = $index) {
                    <tr [formGroupName]="j">
                      <td style="text-align:center">{{pendingBudgetConfiguration.value.budgetName}}</td>
                      <td style="text-align:center">
                        @if (pendingBudgetConfiguration.value.fixedAmount) {
                          <span style="font-size: 20px; color: #212121" > -- </span>
                        }
                        @if (!pendingBudgetConfiguration.value.fixedAmount) {
                          <input
                            type="number"
                            min="0"
                            max="100"
                            pInputText
                            class="text-input"
                            style="font-size: 20px; color: #212121"
                            formControlName="percentage"
                            (change)="calculateValues(i, 'pending')" />
                        }
                        @if (!pendingBudgetConfiguration.value.fixedAmount) {
                          <span> %</span>
                        }
                        @if (pendingBudgetConfiguration.invalid) {
                          <span class="p-invalid">
                            Must be between 0 and 100
                          </span>
                        }
                      </td>
                      <td style="text-align:center">
                        $ @if (pendingBudgetConfiguration.value.fixedAmount) {
                        <input
                          type="number"
                          step="0.01"
                          min="0.00"
                          class="text-input"
                           style="text-align:center;
                                 font-size: 20px;
                                 color: #212121;"
                          formControlName="totalSpend"
                          (change)="calculateValues(i, 'pending')"/>
                      }
                      @if (!pendingBudgetConfiguration.value.fixedAmount) {
                        <span>
                          {{stringFormatterService.formatNumberToString(pendingBudgetConfiguration.value.totalSpend)}}
                        </span>
                      }
                    </td>
                    <td style="text-align:center">
                      <p-toggleswitch
                        formControlName="fixedAmount"
                        (onChange)="calculateValues(i, 'pending')"
                      ></p-toggleswitch>
                    </td>
                    <td style="text-align:center">${{stringFormatterService.formatNumberToString(pendingBudgetConfiguration.value.dailyBudget)}}</td>
                  </tr>
                }
              </ng-container>
              @if (!pendingBudgetConfigurationTotalsFormGroups[i].invalid) {
                <tr style="background:lightgrey">
                  <td style="text-align:center"><i>Total</i></td>
                  <td
                  style="text-align:center">{{pendingBudgetConfigurationTotalsFormGroups[i].controls.percentageTotal.value}} %</td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(pendingBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value)}}</td>
                  <td style="text-align:center"><i> </i></td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(pendingBudgetConfigurationTotalsFormGroups[i].controls.dailyBudgetTotal.value)}}</td>
                </tr>
              }
              @if (pendingBudgetConfigurationTotalsFormGroups[i].invalid) {
                <tr style="background:#FF3838">
                  <td style="text-align:center"><i>Total</i></td>
                  <td
                  style="text-align:center">{{pendingBudgetConfigurationTotalsFormGroups[i].controls.percentageTotal.value}} %</td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(pendingBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value)}}</td>
                  <td style="text-align:center"><i> </i></td>
                  <td
                  style="text-align:center">${{stringFormatterService.formatNumberToString(pendingBudgetConfigurationTotalsFormGroups[i].controls.dailyBudgetTotal.value)}}</td>
                </tr>
              }
            </tbody>
          </table>
          @if (pendingBudgetConfigurationTotalsFormGroups[i].controls.totalSpendTotal.value !== budget.totalBudget && !this.pendingBudgetConfigurationFormArrays[i].dirty) {
            <div >
              The account’s Salesforce Budget was updated. Please update budget configurations.
            </div>
          }
          <div class="tab-panel-input-wrapper" style="margin-top: 12px">
            <button pButton
              class="p-button-success"
              label="Save"
              (click)="handleBudgetConfigurationSave(i,'pending')"
              [disabled]="pendingBudgetConfigurationTotalsFormGroups[i].invalid">
            </button>
          </div>
        </form>
      }
    </div>
    <hr>
    </div>
  }
</p-panel>
